import React from "react";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

import screeningStyles from "./screeningDetails.module.css";
import { IconButton } from "@material-ui/core";
import GhaPickupStatusAwb from "../../models/GhaPickupStatusAwb";
import Awb from "../../models/Awb";
import Forwarder from "../../models/Forwarder";

interface ScreeningAwbInfoComponentProps {
  pickupOrders: Array<GhaPickupStatusAwb>;
  forwarder: Forwarder;
  originDest: Array<KeyValue>;
  exportData: Array<KeyValue>;
  fullFlight: string;
  awb: Awb;
  awbNumber: string;
  handleOpenModal: () => void;
};

interface KeyValue {
  key: string;
  val: string;
};

const screeningAwbInfoComponent = (props: ScreeningAwbInfoComponentProps) => {

  return (
    <div className={ screeningStyles.documentCol }>
      <div className={ screeningStyles.infoParent }>
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>AWB</div>
          <div className={ screeningStyles.docVal }>
            { props.awb.code + "-" + props.awb.number }
          </div>
          <div className={ screeningStyles.docImg }>
            <IconButton
              aria-label="Document"
              onClick={() => props.handleOpenModal()}
            >
              <InsertDriveFileIcon
                color="primary"
                className={ screeningStyles.materialIcon }
              />
            </IconButton>
          </div>
        </div>
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>PCS</div>
          <div className={ screeningStyles.docVal }>{ props.awb.pieces }</div>
        </div>
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>BKD WGT</div>
          <div className={ screeningStyles.docVal }>
            { props.awb.weight + "K" }
          </div>
        </div>
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>ACT WGT</div>
          <div className={ screeningStyles.docVal }>
            { props.pickupOrders[0] ? props.pickupOrders[0].actual_scale_weight + "K" : '-' }
          </div>
        </div>
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>FLIGHT</div>
          <div className={ screeningStyles.docVal }>
            { props.fullFlight }
          </div>
        </div>
        { props.originDest.map((item: KeyValue, i: number) => {
            return (
              <div key={ i } className={ screeningStyles.docLabel }>
                <div className={ screeningStyles.docName }>{ item.key }</div>
                <div className={ screeningStyles.docVal }>
                  { item.val }
                </div>
              </div>
            )
        }) }
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>FWDR</div>
          <div className={ screeningStyles.docVal }>{ props.forwarder.name }</div>
        </div>

        { props.exportData.map((item: KeyValue, i: number) => {
            return (
              <div key={ i } className={ screeningStyles.docLabel }>
                <div className={ screeningStyles.docName }>{ item.key }</div>
                <div className={ screeningStyles.docVal }>
                  { item.val }
                </div>
              </div>
            )
        }) }
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>PROFILE</div>
          <div className={ screeningStyles.docVal }>{  props.pickupOrders[0] && props.pickupOrders[0].shipper_profile }</div>
        </div>
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>CCSF</div>
          <div className={ screeningStyles.docVal }>
            { props.pickupOrders[0] && props.pickupOrders[0].ccsf_approval_number ? 'Yes' : 'No' }
          </div>
        </div>
        { props.pickupOrders[0] && props.pickupOrders[0].ccsf_pre_screened && (
          <div className={ screeningStyles.docLabel }>
            <div className={ screeningStyles.docName }>CCSF #</div>
            <div className={ screeningStyles.docVal }>
              { props.pickupOrders[0] && props.pickupOrders[0].ccsf_approval_number }
            </div>
          </div>
        ) }
        <div className={ screeningStyles.docLabel }>
          <div className={ screeningStyles.docName }>EXCP</div>
          <div className={ screeningStyles.docVal }>
            { props.pickupOrders[0] && props.pickupOrders[0].flight_exception }
          </div>
        </div>
      </div>
    </div>
  );
};

export default screeningAwbInfoComponent;
